var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { ApplicationContext } from '../../../ApplicationContext';
import Signals from '../../../signals/Signals';
import Label from '../../components/ui/Label/Label';
import ActivityStatus from "../../../data/ActivityStatus";
import DateTime from "../../components/ui/DateTime/DateTime";
import ServiceEntryStatus from "../../../data/ServiceEntryStatus";
import { SystemFeatureToggle } from "../../../data/SystemFeatureToggle";
import { AssetDetailTabs } from "./AssetDetail";
import Session from "../../../services/Session";
import Feature from "../../components/ui/Feature/Feature";
/**
 *
 */
var AssetClusterTableRow = /** @class */ (function (_super) {
    __extends(AssetClusterTableRow, _super);
    /**
     *
     */
    function AssetClusterTableRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    /**
     *
     * @returns {*}
     */
    AssetClusterTableRow.prototype.render = function () {
        var _this = this;
        var _a = this.props, assetModel = _a.assetModel, compact = _a.compact, showServiceEntries = _a.showServiceEntries;
        var applicationModel = this.context.applicationModel;
        var properties = assetModel.properties;
        var user = Session.user;
        var newServiceEntries = assetModel.serviceEntries.filter(function (serviceEntryModel) { return serviceEntryModel.calculatedStatus === ServiceEntryStatus.Created; });
        var inProgressServiceEntries = assetModel.serviceEntries.filter(function (serviceEntryModel) { return serviceEntryModel.calculatedStatus === ServiceEntryStatus.InProgress; });
        var classes = classNames({
            'asset-cluster-table-row': true,
            'asset-cluster-table-row--selected': applicationModel ? applicationModel.selectedAsset === assetModel : false
        });
        return (React.createElement("tr", { className: classes, onClick: function () { return _this.showAssetDetail(); } },
            React.createElement("td", { className: "pl-4 text-nowrap" }, properties.displayedId),
            React.createElement("td", { className: "text-nowrap" },
                React.createElement("div", { className: "d-flex align-items-center" }, properties.make)),
            React.createElement("td", { className: "text-nowrap" }, properties.model),
            React.createElement("td", { className: "text-nowrap w-100" }, properties.serialNumber),
            React.createElement(Feature, { hasAny: [SystemFeatureToggle.SERVICEFEATUREPACK], disabled: !showServiceEntries },
                React.createElement("td", { className: 'text-center ' + (compact ? 'text-nowrap' : null), onClick: function (event) {
                        if (newServiceEntries.length > 0) {
                            event.stopPropagation();
                            Signals.HideOverlay.dispatch();
                            Signals.ShowAssetDetail.dispatch(assetModel, AssetDetailTabs.ASSET_SERVICE_ENTRIES);
                        }
                    } },
                    newServiceEntries.length > 0 ?
                        React.createElement("span", { className: "asset-service-entry-notification badge badge-pill badge-success mx-1" }, newServiceEntries.length) : null,
                    inProgressServiceEntries.length > 0 ?
                        React.createElement("span", { className: "asset-service-entry-notification badge badge-pill badge-warning mx-1" }, inProgressServiceEntries.length) : null)),
            React.createElement("td", { className: compact ? 'text-nowrap' : null }, assetModel.labels.map(function (labelModel, index) {
                return React.createElement(Label, { key: index + '-' + labelModel.id, model: labelModel, compact: compact });
            })),
            React.createElement("td", { className: "text-nowrap" },
                React.createElement("span", { className: "small text-muted d-flex" },
                    React.createElement(DateTime, { date: assetModel.lastConnectedDateTime, timeClasses: this.getLocationTimeClasses() })))));
    };
    /**
     *
     */
    AssetClusterTableRow.prototype.showAssetDetail = function () {
        var assetModel = this.props.assetModel;
        Signals.ShowAssetDetail.dispatch(assetModel);
        Signals.HideOverlay.dispatch();
    };
    /**
     *
     * @return {string}
     */
    AssetClusterTableRow.prototype.getLocationTimeClasses = function () {
        var assetModel = this.props.assetModel;
        var classes = '';
        switch (assetModel.activityStatus) {
            case ActivityStatus.EXPIRED:
                classes = 'fe fe-alert-circle text-warning mr-2';
                break;
            case ActivityStatus.NONE:
                classes = 'fe fe-x-circle text-danger mr-2';
                break;
            case ActivityStatus.RECENT:
                classes = 'fe fe-clock mr-2';
                break;
        }
        return classes;
    };
    AssetClusterTableRow = __decorate([
        observer
    ], AssetClusterTableRow);
    return AssetClusterTableRow;
}(React.Component));
AssetClusterTableRow.contextType = ApplicationContext;
export default injectIntl(AssetClusterTableRow);
